import { Spinner } from '@psspl/ui';

/**
 * Suspense fallback while a lazily loaded screen's code arrives.
 *
 * Only ever seen on the first visit to a screen: later navigations run as
 * transitions and keep the current screen on display instead.
 */
export function RouteFallback({ label = 'Loading' }: { readonly label?: string }) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <Spinner size="lg" className="text-brand-400" label={label} />
    </div>
  );
}
